import { render, staticRenderFns } from "./editFixedAssetType.vue?vue&type=template&id=222b831e&scoped=true&"
import script from "./editFixedAssetType.vue?vue&type=script&lang=js&"
export * from "./editFixedAssetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222b831e",
  null
  
)

export default component.exports